// GENERATED from master v4.0.0+mkt (1bbfdf8fe7f9). Do not edit: change the master, then propagate (MASTER-DESIGN-SYSTEM.md, "Changing the master"). body 9da4f8ae58bdc0e2
/* Arctic Grey marketing extension (proposed 4.4.0): the section tabs follow reading.
   A .mk-tabs[data-mk-spy] holds links to sections on the page. The link for the section being read gets
   aria-current="true" and is scrolled into view inside the tab row (never the page). No dependencies. */
(function () {
  var nav = document.querySelector('.ag-mkt [data-mk-spy]');
  if (!nav || !('IntersectionObserver' in window)) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  var items = links.map(function (a) { return { a: a, el: document.getElementById(a.getAttribute('href').slice(1)) }; })
    .filter(function (x) { return x.el; });
  if (!items.length) return;
  var current = null;

  function set(item) {
    if (item === current) return;
    current = item;
    items.forEach(function (x) { if (x === item) x.a.setAttribute('aria-current', 'true'); else x.a.removeAttribute('aria-current'); });
    var left = 0;
    if (item) left = Math.max(0, item.a.offsetLeft - (nav.clientWidth - item.a.offsetWidth) / 2);
    nav.scrollTo({ left: left, behavior: 'auto' });
  }

  function pick() {
    var line = window.innerHeight * 0.35, best = null;
    items.forEach(function (x) { if (x.el.getBoundingClientRect().top <= line) best = x; });
    var first = items[0].el.getBoundingClientRect().top;
    set(first > line ? null : best);
  }

  var io = new IntersectionObserver(pick, { rootMargin: '0px 0px -50% 0px', threshold: [0, 1] });
  items.forEach(function (x) { io.observe(x.el); });
  window.addEventListener('scroll', function () { window.requestAnimationFrame(pick); }, { passive: true });
  pick();
})();

/* Marketing extension 4.4.0: the homepage kit behaviour.
   AGTrack(ev, props): one event call. It pushes to dataLayer, and to the Homepage Lab when the page loads ag-lab.js.
   Reveals ([data-mk-reveal]) and count-ups ([data-mk-count]) run once, when in view.
   AGBook: the booking modal around Calendly's inline calendar. Any [data-mk-book] opens it; the goal picks the event.
   Configure it on the page with window.AGBookConfig = {events:{default, migrate, ...}, colours, who:{name, role, photo}}. */
(function () {
  var W = window, D = document;
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  W.AGTrack = W.AGTrack || function (ev, props) {
    props = props || {};
    var o = { event: ev };
    for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) o[k] = props[k];
    W.__agT = 1; (W.dataLayer = W.dataLayer || []).push(o); W.__agT = 0;
    if (W.AGLab && typeof W.AGLab.track === 'function') W.AGLab.track(ev, props);
  };

  /* Reveals: stagger the children of [data-mk-stagger] */
  function initReveal() {
    var els = [].slice.call(D.querySelectorAll('.ag-mkt [data-mk-reveal]'));
    [].forEach.call(D.querySelectorAll('.ag-mkt [data-mk-stagger]'), function (p) {
      [].forEach.call(p.querySelectorAll(':scope > [data-mk-reveal]'), function (c, i) { c.style.setProperty('--mk-i', Math.min(i, 8)); });
    });
    if (reduce || !('IntersectionObserver' in W)) { els.forEach(function (e) { e.classList.add('mk-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('mk-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    /* A failsafe: nothing stays hidden if the observer never fires (print, odd embeds) */
    setTimeout(function () { els.forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight) e.classList.add('mk-in'); }); }, 2500);
  }

  /* Count-ups: data-mk-count="186" data-mk-decimals="1"; the final value is already in the HTML for crawlers */
  function initCount() {
    var els = [].slice.call(D.querySelectorAll('.ag-mkt [data-mk-count]'));
    if (reduce || !('IntersectionObserver' in W)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, end = parseFloat(el.getAttribute('data-mk-count')), dec = parseInt(el.getAttribute('data-mk-decimals') || '0', 10);
        var pre = el.getAttribute('data-mk-prefix') || '', suf = el.getAttribute('data-mk-suffix') || '', t0 = null, dur = 1100;
        function fmt(v) { return pre + v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; }
        function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(end * e); if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Booking modal */
  var book = null, calLoaded = false, calLoading = null, lastFocus = null;
  function cfg() { return W.AGBookConfig || { events: { default: 'https://calendly.com/arcticgrey-jake/15min' } }; }
  function goalNow() { return D.documentElement.getAttribute('data-mk-goal') || 'default'; }
  function eventUrl(goal) {
    var c = cfg(), ev = c.events || {}, base = ev[goal] || ev['default'];
    var col = c.colours || 'background_color=ffffff&text_color=111113&primary_color=1a1a1a';
    return base + (base.indexOf('?') < 0 ? '?' : '&') + 'hide_event_type_details=1&' + col;
  }
  function loadCalendly() {
    if (calLoaded) return Promise.resolve();
    if (calLoading) return calLoading;
    calLoading = new Promise(function (res, rej) {
      var s = D.createElement('script');
      s.src = 'https://assets.calendly.com/assets/external/widget.js'; s.async = true;
      s.onload = function () { calLoaded = true; res(); }; s.onerror = rej;
      D.head.appendChild(s);
    });
    return calLoading;
  }
  function touch() {
    try { return JSON.parse(localStorage.getItem('ag_last_touch') || localStorage.getItem('ag_first_touch') || 'null') || {}; } catch (e) { return {}; }
  }
  function build() {
    var c = cfg(), who = c.who || {};
    var root = D.querySelector('.ag-mkt') || D.body;
    book = D.createElement('div');
    book.className = 'mk-book'; book.setAttribute('role', 'dialog'); book.setAttribute('aria-modal', 'true'); book.setAttribute('aria-labelledby', 'mk-book-title');
    book.innerHTML =
      '<div class="mk-book__scrim" data-mk-book-close></div>' +
      '<div class="mk-book__panel">' +
        '<button type="button" class="mk-book__x" data-mk-book-close aria-label="Close"></button>' +
        '<aside class="mk-book__side">' +
          '<p class="mk-eyebrow">Book a call</p>' +
          '<h2 id="mk-book-title" class="mk-h3" style="font-size:22px">' + (c.title || 'Pick a time that suits you.') + '</h2>' +
          (who.name ? '<div class="mk-book__who">' + (who.photo ? '<img src="' + who.photo + '" alt="" width="52" height="52">' : '') + '<div><b>' + who.name + '</b><span class="mk-meta">' + (who.role || '') + '</span></div></div>' : '') +
          '<ul class="mk-ticks mk-book__more">' + (c.points || ['15 minutes, on video or by phone.', 'Tell us what you need. We tell you how we would do it, and what it takes.', 'No pressure and no obligation.']).map(function (p) { return '<li><span class="mk-ring mk-ring--ink" aria-hidden="true"></span><span>' + p + '</span></li>'; }).join('') + '</ul>' +
          '<p class="mk-meta mk-book__more">Prefer to write? <a class="mk-link" href="' + (c.formUrl || '/pages/form') + '">Send us your brief</a>.</p>' +
        '</aside>' +
        '<div class="mk-book__cal"><div class="mk-book__loading" role="status">Loading the calendar</div><div class="mk-book__done" role="status" aria-live="polite"><span class="mk-ring mk-ring--check" style="width:44px;height:44px;background-size:44px 44px" aria-hidden="true"></span><h3 class="mk-h3" style="font-size:22px">You are booked.</h3><p class="mk-body">The invite is in your inbox. We will come prepared.</p><button type="button" class="mk-btn" data-mk-book-close>Back to the page</button></div></div>' +
      '</div>';
    root.appendChild(book);
    book.addEventListener('click', function (e) { if (e.target.closest('[data-mk-book-close]')) close(); });
    D.addEventListener('keydown', function (e) {
      if (!book.hasAttribute('data-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = [].slice.call(book.querySelectorAll('button,a[href],iframe,[tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && D.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && D.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    W.addEventListener('message', function (e) {
      if (!e.data || typeof e.data.event !== 'string' || e.data.event.indexOf('calendly.') !== 0) return;
      if (!/calendly\.com$/.test((e.origin || '').replace(/^https?:\/\//, ''))) return;
      var name = e.data.event.replace('calendly.', '');
      if (name === 'event_type_viewed') { var l = book.querySelector('.mk-book__loading'); if (l) l.hidden = true; }
      if (name === 'date_and_time_selected') W.AGTrack('book_call_time_selected', { goal: book.getAttribute('data-goal') });
      if (name === 'event_scheduled') { book.setAttribute('data-booked', ''); W.AGTrack('book_call_booked', { goal: book.getAttribute('data-goal') }); }
    });
  }
  function open(goal, source) {
    if (!book) build();
    goal = goal || goalNow();
    lastFocus = D.activeElement;
    book.setAttribute('data-goal', goal); book.removeAttribute('data-booked');
    book.setAttribute('data-open', ''); D.documentElement.classList.add('mk-lock');
    var x = book.querySelector('.mk-book__x'); if (x) x.focus();
    W.AGTrack('book_call_open', { goal: goal, source: source || '' });
    var cal = book.querySelector('.mk-book__cal'), url = eventUrl(goal);
    if (cal.getAttribute('data-url') === url) return;
    cal.setAttribute('data-url', url);
    [].forEach.call(cal.querySelectorAll('iframe,.calendly-inline-widget,.calendly-spinner'), function (n) { n.remove(); });
    var l = cal.querySelector('.mk-book__loading'); if (l) l.hidden = false;
    loadCalendly().then(function () {
      var t = touch();
      W.Calendly.initInlineWidget({
        url: url, parentElement: cal, resize: false,
        prefill: { customAnswers: { a2: (cfg().notes && cfg().notes[goal]) || '' } },
        utm: { utmSource: t.utm_source || t.source || '', utmMedium: t.utm_medium || t.medium || '', utmCampaign: t.utm_campaign || t.campaign || '', utmContent: goal, utmTerm: t.utm_term || '' }
      });
    }).catch(function () { W.location.href = url; });
  }
  function close() {
    if (!book) return;
    book.removeAttribute('data-open'); D.documentElement.classList.remove('mk-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  W.AGBook = { open: open, close: close };
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mk-book]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-mk-book') || goalNow(), t.getAttribute('data-mk-cta') || '');
  });
  /* Warm the calendar script when someone reaches for a booking button */
  ['pointerover', 'focusin', 'touchstart'].forEach(function (evn) {
    D.addEventListener(evn, function (e) { if (e.target.closest && e.target.closest('[data-mk-book]')) loadCalendly().catch(function () {}); }, { passive: true, once: false });
  });
  if (/(^|[?&#])book(=|&|$)/.test(location.search + location.hash)) setTimeout(function () { open(); }, 300);

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initReveal(); initCount(); });
  else { initReveal(); initCount(); }
})();

/* The editorial tier (4.5.0, proposed).
   Cinema hero ([data-mk-cinema]): sets (.mk-cinema__set) crossfade every 6.5 s; the frames drift while their set shows.
   It pauses off screen, while the tab is hidden and under reduced motion (one still set). Dots ([data-mk-cinema-dots])
   pick a set. The frames are decorative (aria-hidden); a polite live region names the brands now showing.
   Bento visuals ([data-mk-viz]) run only while in view (.is-live). */
(function () {
  var W = window, D = document;
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn) { [].forEach.call(D.querySelectorAll(sel), fn); }
  each('.ag-mkt [data-mk-cinema]', function (root) {
    var sets = [].slice.call(root.querySelectorAll('.mk-cinema__set'));
    var dots = root.querySelector('[data-mk-cinema-dots]');
    var live = root.querySelector('[data-mk-cinema-live]');
    if (sets.length < 2) return;
    var i = 0, timer = null, inView = true;
    function lazy(set) {
      [].forEach.call(set.querySelectorAll('img[data-src]'), function (img) {
        if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.src = img.getAttribute('data-src'); img.removeAttribute('data-src');
      });
    }
    function show(n) {
      i = (n + sets.length) % sets.length;
      lazy(sets[i]); lazy(sets[(i + 1) % sets.length]);
      sets.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (dots) [].forEach.call(dots.children, function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      if (live) live.textContent = sets[i].getAttribute('data-label') || '';
    }
    function play() { stop(); if (!reduce && inView && !D.hidden) timer = setInterval(function () { show(i + 1); }, 6500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (dots) {
      dots.textContent = '';
      sets.forEach(function (s, k) {
        var b = D.createElement('button'); b.type = 'button';
        b.setAttribute('aria-label', 'Show ' + (s.getAttribute('data-label') || 'set ' + (k + 1)));
        b.addEventListener('click', function () { show(k); play(); });
        dots.appendChild(b);
      });
    }
    show(0);
    /* Load the next set once the page has settled, so the first switch is seamless */
    W.addEventListener('load', function () { setTimeout(function () { lazy(sets[1]); }, 1200); });
    if ('IntersectionObserver' in W) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; if (inView) play(); else stop(); }).observe(root);
    D.addEventListener('visibilitychange', function () { if (D.hidden) stop(); else play(); });
    play();
  });
  if ('IntersectionObserver' in W) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting && !reduce); }); }, { rootMargin: '80px' });
    each('.ag-mkt [data-mk-viz]', function (el) { io.observe(el); });
  }
})();
